import axios from 'config/axios';
import env from 'config/env';
import { useState } from 'react';
import Swal from 'sweetalert2';

export default function useImageData() {
  const [loading, setLoading] = useState(false);

  const deleteimg = async rno => {
    axios.defaults.withCredentials = true;
    try {
      setLoading(true);
      await axios.post(`${env.apiURL}/invoice/delete_image/${rno}`);
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Success',
        text: 'Deleted Successfully',
        confirmButtonColor: '#2778c4',
        showConfirmButton: true,
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Cannot Delete Image',
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const updateOcr = async (summId, data, status) => {
    axios.defaults.withCredentials = true;
  
    let payloadBody = data.map(elem => {
      console.log(elem.date);
      let bodyElements = {
        invoice_receipt_date: elem.date,
        tax: elem.tax,
        subtotal: elem.subtotal,
        total: elem.total,
        vendor_name: elem.vendorName,
        inv_status: status,
        receiver_address: elem.jsonData.RECEIVER_ADDRESS,
      };
      return bodyElements;
    });
    try {
      setLoading(true);
      await axios.put(`${env.apiURL}/invoice/edit/${summId}`, {
        data: { ...payloadBody[0] },
      });
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Success',
        text: 'Invoice Updated Successfully',
        confirmButtonColor: '#2778c4',
        showConfirmButton: true,
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Cannot Update OCR Data',
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return { deleteimg, updateOcr, loading };
}
